import { NavigateProps } from 'react-router';

import { TPermissions, TUserRoles } from '@cloud-wave/neon-common-lib';

import { usePermissionsContext } from '../contexts/PermissionsContext';
import { useHistory } from '../hooks/useHistory';
import { TConnectPermissions, TPermissionTypes } from '../types/Permissions';

interface IPermissionRedirect {
  route: string;
  permission: TPermissions | TConnectPermissions;
  permissionType?: TPermissionTypes;
}

// This is used to redirect to a certain route if the role exists. eg. sub nav routes
export default function PermissionRedirect({
  redirects,
  allowedRoles,
  ...props
}: Omit<NavigateProps, 'to'> & { redirects: IPermissionRedirect[]; allowedRoles: TUserRoles[] }) {
  const { hasPermission, role } = usePermissionsContext();
  const { Navigate } = useHistory();
  const hasCorrectRole = allowedRoles.length ? allowedRoles.includes(role) : true;

  if (!hasCorrectRole) {
    return null;
  }

  const redirect = redirects.find(({ permission, permissionType }) =>
    hasPermission({ type: permissionType, permission })
  );

  if (!redirect) {
    return null;
  }

  return <Navigate {...props} to={redirect.route} />;
}
